import Precioso from "./Precioso";
import Form from "../Formulario/Form";
import PricesDataForm from "../Formulario/PricesDataForm";
//import "../../Styles/hamlet.css";
import { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  Container,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { useNavigate } from "react-router-dom";
import AddFloatButton from "../General/AddFloatButton";
import { AuthContext } from "../context/AuthContext";
import { useContext } from "react";
import Fetch from "../General/Fetch";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import {
  currencyCotization,
  currencyFormat,
} from "../utils/generalData/numbersAndCurrencies";
import Spinner from "../General/Spinner";
import MainContainer from "../Pages/MainContainer"

const PricesMainContainer = () => {
  const [useNewPrice, setNewPrice] = useState(false);
  const navigate = useNavigate();
  const collection = "precios";
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [useTable, setTable] = useState(false);
  const [cotizations, setCotizations] = useState([]);
  const [cotizationEnable, setCotizationEnable] = useState(false);
  const context = useContext(AuthContext);

  const validateAdminUser = () => {
    if (
      context.useLogin === true &&
      context.memberships[0]?.role.toLowerCase() === "admin"
    ) {
      return true;
    } else {
      setError({ message: "Acceso denegado: Contacte al administrador" });
      setLoading(false);
      return;
    }
  };

  const handleChange = () => {
    setTable(!useTable);
  };

  useEffect(() => {
    validateAdminUser();
    const fetchCotization = async (codes) => {
      try {
        const results = await Promise.all(
          codes.map((code) => currencyCotization(code)),
        );
        if (!results || results.some((result) => result instanceof Error)) {
          setCotizationEnable(false);
          throw new Error("Error obteniendo cotizacion.");
        }
        setCotizations(results);
        setCotizationEnable(true);
        setLoading(false);
      } catch (error) {
        setCotizationEnable(false);
        setLoading(false);
      }
    };

    fetchCotization(["usd", "eur", "brl"]);
  }, []);

  const failure = (
    <Container>
      <ErrorMessage
        message={error?.message || "Unknown error"}
        action={() => {
          setLoading(false);
          setError(null);
          setCotizationEnable(false);
        }}
        buttonTxt={"Aceptar"}
        title="Error de BCRA"
      />
    </Container>
  );

  const loadingComponent = <Spinner />;

  const success = (
    <Container >
      {
        //validateAdminUser() &&
        <Card>
          <CardHeader
            title={collection}
            subheaderTypographyProps={{
              variant: "subtitle1",
            }}
            subheader={
              cotizationEnable ? (
                cotizations.length > 0 ? (
                  cotizations
                    .map(
                      (cot) =>
                        `${
                          cot.results[0].detalle[0].descripcion
                        }: ${currencyFormat(
                          cot.results[0].detalle[0].tipoCotizacion,
                        )}`,
                    )
                    .join(", ")
                ) : (
                  <Container>
                    <ErrorMessage
                      message={error?.message || "Cotizaciones no disponibles"}
                      severity="info"
                      variant="outlined"
                    />
                  </Container>
                )
              ) : (
                <Container>
                  <ErrorMessage
                    message={
                      error?.message ||
                      "Cotizacion Moneda extranjera no disponible"
                    }
                    severity="info"
                    variant="standard"
                  />
                </Container>
              )
            }
            action={
              <ToggleButtonGroup
                value={useTable}
                exclusive
                onChange={handleChange}
                color="info"
                orientation="horizontal"
              >
                <ToggleButton value="list" aria-label="list">
                  <ViewListIcon color="info" />
                </ToggleButton>
                <ToggleButton value="module" aria-label="module">
                  <ViewModuleIcon color="info" variant="contained" />
                </ToggleButton>
              </ToggleButtonGroup>
            }
          />
          <CardContent>
            {useTable ? (
              <Fetch collection="precios" title="Costos" />
            ) : (
              <Precioso
                collection="precios"
                priceState={useNewPrice}
                cotization={
                  cotizations[0] !== undefined
                    ? cotizations[0].results[0].detalle[0].tipoCotizacion
                    : 1
                }
              />
            )}
          </CardContent>
          <CardActions>
            <AddFloatButton
              text={"Agregar " + collection}
              onclick={() => navigate(`/precios/add`)}
            />
          </CardActions>
        </Card>
      }
    </Container>
  );

  return loading ? loadingComponent : error !== null ? failure : success;
};

export default PricesMainContainer;
